interface HtmxEvent extends Event {
  detail: {
    target: HTMLElement
  }
}

const ValitorModal = {
  el: {
    modalClose: document.querySelector<HTMLElement>('#response-modal-close'),
    responseCredit: document.querySelector<HTMLElement>('#response-credit'),
    responseModal: document.querySelector<HTMLElement>('#response-modal'),
    form: document.querySelector<HTMLFormElement>('#attachCreditCardToKeys'),
  },

  init() {
    if (!this.el.responseCredit) return
    this.el.modalClose.addEventListener('click', (e) => {
      e.preventDefault()
      this.el.responseModal.classList.add('hidden')
      this.el.responseCredit.innerHTML = ''
    })

    window.addEventListener('htmx:afterRequest', (e: HtmxEvent) => {
      if (e.detail.target.id === 'response-credit') {
        const params = new URL(location.href).searchParams
        const success = params.get('success') === 'true'

        if (!success) {
          this.el.responseModal.classList.remove('hidden')
        }
      }
    })

    window.addEventListener(
      'message',
      (event) => {
        switch (event.data.type) {
          case '3D_DONE':
          case '3D_Error':
            console.log('3D_DONE')
            this.el.responseModal.classList.add('hidden')
            this.el.responseCredit.innerHTML = ''
            break
          default: // fallback for old object
            if (event.data === '3D_DONE') {
              this.el.responseModal.classList.add('hidden')
              this.el.responseCredit.innerHTML = ''
            }
            break
        }
      },
      false
    )
  },
}

export default ValitorModal
